import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./styles.css";
import { registerServiceWorker } from "./state/swRegistry.ts";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Offline support. Registered after load so it never competes with the first
// paint. Not fatal if it fails — the app works online without it — but the
// failure is recorded so the menu can say so rather than claiming it is still
// being set up.
window.addEventListener("load", registerServiceWorker);
